'use client';

import styles from "@/styles/menu.module.scss";
// import Image from "next/image";

import useStore from "@store/index";
import { formatCurrency, removeSpacesFromString } from "_services/common.service";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { Plus } from "react-feather";
import { ItemObj } from "../modals/order-details-sheet";
import { CommonResponse, submitCollection, submitSets } from "_services/submit.service";
import { loadingService } from "_services/loading.service";
import { useEffect, useState } from "react";
import ItemComponent from "../pages/itemview";
import { Category } from "./category-card";
import ComboComponent, { ComboObject } from "../pages/combo";
import Image from "next/image";
import { RemoveScroll } from "react-remove-scroll";
import CustomTooltip from "../common/customtooltip";
import RichTextViewer from "../common/richtextviewer";
import axios from "axios";
import { cookingLoadingService } from "_services/loadingCooking.service";
import { event } from "@lib/ga";

interface BottomSheetProps {
  show: boolean;
  onHide: () => void;
  onReset: () => void;
  title: string;
  children: React.ReactNode;
}

const BottomSheet = ({ show, onHide, title, children }: BottomSheetProps) => (<>
  <div className={
    show
      ? `${styles.bottomSheetBackdrop} ${styles.showBottomSheetBackdrop} bottomSheetContainer`
      : `${styles.bottomSheetBackdrop} bottomSheetContainer`
  }></div>

  <div className={`${styles.itemBottomSheet} ${show ? styles.showSheet : ''}`}>
    <div className={styles.sheetHeader}>
      <h2 className={styles.sheetTitle}>{title.substring(0,55) + (title?.length > 55? '...' : '')}</h2>
      <button className={styles.resetButton} id={`combo-bottom-sheet-reset-button`} onClick={onHide}>CLOSE</button>
    </div>
    {children}
  </div>
</>);

export default function ItemCard(props: { pizza: ItemObj, itemId?: string }) {
  const t = useTranslations();
  const router = useRouter();
  const { pizza, itemId } = props;
  
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [bottomSheetContent, setBottomSheetContent] = useState<unknown | null>(null);
  const [isHalfAndHalf, setIsHalfAndHalf] = useState(false);
  const [isComboDeal, setIsComboDeal] = useState(false);

  useEffect(() => {
    const isComboDeal = (pizza?.categories?.filter(cat => 
      cat.categoryName.toLowerCase().includes("buy more") ||
      cat.categoryName.toLowerCase().includes("combo")) || []
    ).length > 0;
    setIsComboDeal(isComboDeal);
  }, [pizza]);

  const handleClickItem = () => {
    const { setSelectedItem } = useStore.getState();
    setSelectedItem(pizza);
    cookingLoadingService.loading(true);

    const isComboDeal = pizza.categories.filter(cat => (
      cat.categoryName.toLowerCase().includes("combo") ||
      cat.categoryName.toLowerCase().includes("buy more")
    )).length > 0;

    if(isComboDeal){
      event({
        action: 'navigate_to_combo',
        category: 'combo_interaction',
        label: pizza.itemName,
      });

      const comboPath = `/combo/${pizza.itemName}`;
      router.push(comboPath);
    } else{
      event({
        action: 'navigate_to_item',
        category: 'item_interaction',
        label: pizza.itemName,
      });

      const itemPath = `/item/${pizza.itemName}`;
      router.push(itemPath);
    }
    // const targetPath = isComboDeal 
    //     ? `/combo/${pizza.itemName}` 
    //     : `/item/${pizza.itemName}`;
      
    //   router.push(targetPath);

  }

  
  const handleClickQuickAdd = async (item: ItemObj) => {
    // console.log(item);
    const isComboDeal = (item?.categories?.filter(cat => 
      cat.categoryName.toLowerCase().includes("buy more") ||
      cat.categoryName.toLowerCase().includes("combo")) || []
    ).length > 0;

    loadingService.loading(true);

    let itemDetailsRes: (CommonResponse | null) = null;

    if(isComboDeal){
      const handlerId = `combo:details:${(item?.itemName || "").replace(/\s+/g, '') || "unknown"}`;

      const respObj = await axios.post('/api/submit', {
        urlId: handlerId,
        callstat: submitCollection.loadDealOptions,
        cobj: {
          "dealId": "",
          "dealName": item.itemName
        },
        showalerts: false,
        options: null
      });

      if(respObj && respObj.status === 200 && respObj.data){
        itemDetailsRes = respObj.data;

        event({
          action: 'quick_add_combo',
          category: 'combo_interaction',
          label: item.itemName,
        });
      }

        itemDetailsRes = await submitSets(submitCollection.loadDealOptions,{
          "dealId": "",
          "dealName": item.itemName
        }, false, null);
        
        console.log("itemDetailsRes",itemDetailsRes);

    } else{
      const handlerId = `item:details:${(item?.itemName || "").replace(/\s+/g, '') || "unknown"}`;

      const respObj = await axios.post('/api/submit', {
        urlId: handlerId,
        callstat: submitCollection.loadItemDetails,
        cobj: {
          "itemId": item.itemId,
          "itemName": item.itemName
        },
        showalerts: false,
        options: null
      });

      if(respObj && respObj.status === 200 && respObj.data){
        itemDetailsRes = respObj.data;

        event({
          action: 'quick_add_item',
          category: 'item_interaction',
          label: item.itemName,
        });
      }

        /* itemDetailsRes = await submitSets(submitCollection.loadItemDetails,{
          "itemId": item.itemId,
          "itemName": item.itemName
        }, false, null); */

    }
    // console.log(itemDetailsRes);
    loadingService.loading(false);

    if(itemDetailsRes && itemDetailsRes.status){
      const loadedItemDetails = itemDetailsRes.extra || null;
      const isHalfAndHalf = !isComboDeal?(loadedItemDetails as ItemObj)?.categories?.some((cat: unknown) => (cat as Category).categoryName.toLowerCase().includes("half")) || false:false;

      setIsComboDeal(isComboDeal);
      setIsHalfAndHalf(isHalfAndHalf);

      setBottomSheetContent(loadedItemDetails);
      setShowBottomSheet(true);
    } else{
      // Show error message
      console.error('Error loading item details');
      loadingService.loading(false);
    }

  }

  // console.log(pizza);

  const isItemDescAvailable = (pizza.itemDescription && pizza.itemDescription.trim() !== ""? true : false);
  
  return (<>
  <RemoveScroll enabled={showBottomSheet}>
    <div className={styles.itemCard} 
      onClick={() => (pizza?.isSoldOut ? handleClickQuickAdd(pizza) : handleClickItem())} 
      id={itemId || `item-${pizza.itemId}-link`}
      data-item={removeSpacesFromString(pizza.itemName)}
      >
      <div className={styles.pizzaCard+ (pizza.isSoldOut ? ` ${styles.outOfStock}` : '')}>
        
        {(pizza?.attributes || []).some(attr => attr.attributeName === "highlight_tag" && attr.attributeValue.toLowerCase() === 'new') && <div className={styles.newBadge}>{t('HomePage.NEW')}</div>}
        {(pizza?.attributes || []).some(attr => attr.attributeName === "highlight_tag" && attr.attributeValue.toLowerCase() === 'best') && <div className={styles.newBadge + ' ' + styles.bestBadge}>{t('HomePage.BEST')}</div>}

        {pizza.isSoldOut && <div className={styles.outOfStock}>{t('HomePage.OUT_OF_STOCK')}</div>}

        <div className={styles.pizzaImage}>
          <div className={styles.imageContainer}>
            <Image src={pizza.imageUrls && pizza.imageUrls.length > 0 && pizza.imageUrls[0].imageUrl? pizza.imageUrls[0].imageUrl:
             pizza.imageUrls && pizza.imageUrls.length > 0 && pizza.imageUrls[0].url? pizza.imageUrls[0].url: '/assets/images/placeholder.png'

            } alt={pizza.itemName} fill className={styles.imageElem} sizes="(max-width: 600px) 100vw, 50vw"
            onError={(e) => { (e.target as HTMLImageElement).src = '/assets/images/placeholder.png'; }}
            />
          </div>

          {/* <Image
            src={pizza.imageUrls ? pizza.imageUrls[0].imageUrl : ''}
            alt={pizza.itemName}
            width={136}
            height={122}
            className={styles.imageElem}
          /> */}
          {pizza.tags && (
            <div className={styles.tags}>
              {pizza.tags.map((tag) => (
                <div key={tag} className={`${styles.tag} ${styles[tag.toLowerCase()]}`}>
                  {tag}
                </div>
              ))}
            </div>
          )}
        </div>
        
       {/* <OverlayTrigger
          delay={{ show: 10, hide: 100 }}
          overlay={(props) => (
              <Tooltip {...props}>{ pizza.isVegetarian !== null && (
                pizza.isVegetarian ? t('VEGETARIAN') : t('NON_VEGETARIAN')
            )}</Tooltip>)}
        >
          <div className={
              pizza.isVegetarian === null
                ? `${styles.hidden}`
                : `${styles.vegetarian}${!pizza.isVegetarian ? ` ${styles.nonVeg}` : ''}`
            }
          >
            <span className={styles.dot}></span>
          </div> 
        </OverlayTrigger>  */}

        <div className={styles.vegDiv}>
          <CustomTooltip
            placement="top"
            overlayContent={ (typeof pizza.isVegetarian !== 'undefined' && pizza.isVegetarian !== null) && (
                  pizza.isVegetarian ? t('VEGETARIAN') : t('NON_VEGETARIAN')
              )}
            scrollElement={null}
          >
            <div className={
                (typeof pizza.isVegetarian === 'undefined' || pizza.isVegetarian === null)
                  ? `${styles.hidden}`
                  : `${styles.vegetarian}${!pizza.isVegetarian ? ` ${styles.nonVeg}` : ''}`
              }
            >
              <span className={styles.dot}></span>
            </div>
          </CustomTooltip>
        </div>
        
        <div className={styles.pizzaInfo}>
          <CustomTooltip
            placement="top"
            overlayContent={ pizza.itemName !== null && (
                  pizza.itemName
              )}
            scrollElement={null}
          >
            <h3 className={isItemDescAvailable ? styles.shortTitle : styles.longTitle}>{pizza.itemName.substring(0, (isItemDescAvailable?22:42)) + (pizza.itemName.length > (isItemDescAvailable?22:42) ? '...' : '')}</h3>
          </CustomTooltip>

          {/* <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props}>
              { pizza.itemName !== null && (
                  pizza.itemName
              )}
              </Tooltip>
            )}
            placement="top">
              <h3>{pizza.itemName.substring(0, 22) + (pizza.itemName.length > 22 ? '...' : '')}</h3>
          </OverlayTrigger> */}

          {/* <OverlayTrigger
            overlay={(props) => (
              <Tooltip {...props}>
                {pizza.itemDescription}
              </Tooltip>
            )}
            placement="top">
            <p>{pizza.itemDescription !== null && (
                  pizza.itemDescription.substring(0, 55) + (pizza.itemDescription.length > 55 ? '...' : '')
            )}</p>
          </OverlayTrigger> */}

          {pizza.itemDescription && pizza.itemDescription.trim() !== "" ? (
            // <OverlayTrigger
            //   overlay={(props) => (
            //     <Tooltip {...props}>
            //       {pizza.itemDescription}
            //     </Tooltip>
            //   )}
            //   placement="top"
            // >
            //   <p>
            //     {pizza.itemDescription.substring(0, 55) +
            //       (pizza.itemDescription.length > 55 ? '...' : '')}
            //   </p>
            // </OverlayTrigger>

            <CustomTooltip
              placement="top"
              overlayContent={<RichTextViewer html={pizza.itemDescription} />}
              scrollElement={null}
            >
            <div className={styles.descriptionTooltipSpacer}>
                <RichTextViewer html={pizza.itemDescription.substring(0, 42) + (pizza.itemDescription.length > 42 ? '...' : '')} />
            </div>
            </CustomTooltip>

          ) : (
            <p></p>
          )}
        </div>


        <div className={styles.priceRow}>
          {/* {!pizza.isSoldOut && <span className={styles.priceText}>ADD</span>} */}
          {/* {!pizza.isSoldOut && <span className={styles.priceText}>ADD</span>} */}
          <div className={styles.priceSizeContainer}>
            {/* {(!pizza.itemName.toLowerCase().includes('buy more') && !pizza.itemName.toLowerCase().includes('deal'))? <> */}
            {!isComboDeal? <>
              <span className={styles.price}>{formatCurrency((pizza.price?.amount || 0), (pizza.price?.currency || 'USD'))}</span>
              {(pizza?.variations || []).length > 1 && (pizza?.variations || []).filter(v => v.isApplied)
                .map(v => (
                  <span className={styles.priceSize} key={v.variationId}>{v.variationName}</span>
                ))
              }
            </>:<>
              {pizza && pizza.price && pizza.dealPriceApplyMode === 'fix_amount' && pizza.dealPriceAmountType === 'amount' && (pizza?.discountApplyScope === 'total_items_amount')? 
              <span className={styles.price}>{formatCurrency((pizza.price?.amount || 0), (pizza.price?.currency || 'USD'))}</span> : 
              <span className={styles.priceText}>ADD</span>}
            </>}
          </div>
          {!pizza.isSoldOut && <button className={styles.addButton} 
            onClick={(e) => { e.stopPropagation(); handleClickQuickAdd(pizza) }} 
            aria-label={`Add ${pizza.itemName} to cart`}
            data-id="quick-add"
            >
            <Plus size={16} style={{ color: "#fff" }} />
          </button>}
        </div>
      </div>
    </div>

    {showBottomSheet && (
      <BottomSheet 
      show={showBottomSheet} 
      onHide={() => setShowBottomSheet(false)} 
      onReset={() => setBottomSheetContent(null)} 
      title={
        isComboDeal ? ((bottomSheetContent as ComboObject)?.dealName || '') :
        ((bottomSheetContent as ItemObj)?.itemName || '')}
      > 
        <>
        {isComboDeal?
          <ComboComponent 
            comboItemObj={bottomSheetContent as ComboObject} 
            isBottomSheet={true} 
            toggleBottomSheet={() => setShowBottomSheet(false)} 
            />
        :
          <ItemComponent 
            loadedItemDetails={bottomSheetContent as ItemObj} 
            isHalfAndHalf={isHalfAndHalf} 
            isBottomSheet={true} 
            toggleBottomSheet={() => setShowBottomSheet(false)}
            isComboHalfAndHalf={false}
            totalPriceInc={'0.00'}
            onModifierChange={() => {}}
            handleSlideChange={() => {}}
            setModifiers={() => {}}
            />
        }
        </>
      </BottomSheet>
    )}
    </RemoveScroll>
  </>);
}

